import { ImageDetailsDto } from '@/api/generated/HCA/api'
import { useImageBlobCacheStore } from '@/store/imageBlobCacheStore'
import { downloadFile } from '@/utils/file-utils'
import { usePebbleToasts } from './pebble/usePebbleToasts'
import { useI18n } from 'vue-i18n'

export const useGeneratorImageBlobDownloads = () => {
    const { t } = useI18n()
    const toasts = usePebbleToasts()
    
    const imageBlobCache = useImageBlobCacheStore()

    const downloadImage = async (image: ImageDetailsDto) => {
        if (!image.imagePath) {
            return
        }
        try {
            const blob = await imageBlobCache.getImageBlob(image.imagePath)
            downloadFile(blob, image.fileName ?? 'downloaded_image')
        } catch (error) {
            console.error('Failed to download image:', error)
            toasts?.error({
                message: t('common.errors.unknown'),
                duration: 3000,
            })
        }
    }

    const downloadAll = async (images: ImageDetailsDto[]) => {
        for (const image of images) {
            if (!image.imagePath) {
                continue
            }
            try {
                const blob = await imageBlobCache.getImageBlob(image.imagePath)
                downloadFile(blob, image.fileName ?? 'downloaded_image')
            } catch {
                /* continue batch */
            }
        }
    }

    return { downloadImage, downloadAll }
}
